// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dfb34131","925":"c48fd7f2"}[chunkId] + ".chunk.js";
};